export default {
  text: 'rgb(190, 172, 116)',
  primary: '#471452',
  secondary: '#702082',
  background: 'black',
  backgroundSecondary: '#202020',
  light: '#FFF',
  dark: '#020303'
}
